/* eslint-disable max-len */
import { Modal, Spin } from 'antd';
import React, { CSSProperties, useEffect, useState } from 'react';
import SoilProfilePreview from '@/page/Soil/soil-profile/Component/SoilProfilePreview';
import {
    soilProfileGetLayersDetail,
    soilProfileGetSoilProfileDetail
} from '../../../../util/Request';
import {
    GetPropertyListResponseModel,
    ISoilProfileGetLayersDetailResModel,
    ISoilProfileGetSoilDetailResModel
} from '../../../../util/Request/requestType';
import './index.less';
import { SoilCloseIcon } from '@/resource/IconComponentSets';

interface IProps {
    style?: CSSProperties,
    className?: string,
    lat?: number,
    lng?: number,
    profileId?: number,
    profileCode?: string,
    onClick?: (e) => void,
    children?: React.ReactNode,
    key?: string | number,
    keyString?: string | number,
    propertySet?: GetPropertyListResponseModel[]
}

const SoilProfileMarker = (props: IProps) => {
    const {
        profileCode,
        profileId,
        propertySet,
        keyString
    } = props;
    const [visible, setVisible] = useState(false);
    const [spinning, setSpinning] = useState(false);
    const [profileDetail, setProfileDetail] = useState<ISoilProfileGetSoilDetailResModel>();
    const [layerDetail, setLayerDetail] = useState<ISoilProfileGetLayersDetailResModel[]>();
    const [profileDatailSpin, setProfileDatailSpin] = useState(false);
    const [soilProfilePreviewVsible, setSoilProfilePreviewVsible] = useState(false);
    const [yPoint, setYPoint] = useState<string>('-260');
    const [xPoint, setXPoint] = useState<string>('-20');

    const hoverCallBack = async (isEnter) => {
        try {
            setVisible(isEnter);
            if (isEnter && !profileDetail) {
                setSpinning(true);
                const response = await soilProfileGetSoilProfileDetail(profileCode);
                setProfileDetail(response);
                setSpinning(false);
            }
        } catch (err) {
            console.log('err', err);
            setSpinning(false);
        }
    };

    const clickBUttonToSHowProfileDetail = async () => {
        try {
            setSoilProfilePreviewVsible(true);
            setProfileDatailSpin(true);
            const profileDetail = await soilProfileGetSoilProfileDetail(profileCode);
            const layerDetail = await soilProfileGetLayersDetail(profileId);
            setProfileDetail(profileDetail);
            setLayerDetail(layerDetail);
            // calculate the location of profile detail div

            setProfileDatailSpin(false);
        } catch(err) {
            console.log('err', err);
            setProfileDatailSpin(false);
        }
    };

    useEffect(() => {
        if (visible) {
            const targetDiv = document.getElementById(`visible-div-marker-${keyString}-inner`);
            const top = targetDiv.getBoundingClientRect().top;
            const distanceToLeft = targetDiv.getBoundingClientRect().right;
            const mapDiv = document.getElementById('app-component');
            const screenWidth = mapDiv.getBoundingClientRect().width;

            const right = screenWidth - distanceToLeft;

            if (top > 300) {
                setYPoint(`${-(260 + 52)}px`);
            }

            if (top < 300) {
                setYPoint(`${-top}px`);
            }

            if (right > (328)) {
                setXPoint(`${-42/2}px`);
            }

            if (right < (328)) {
                setXPoint(`${328 + 42/2}px`);
            }
        }
    }, [visible, keyString]);

    return (
        <div
            onMouseEnter={() => hoverCallBack(true)}
            onMouseLeave={() => hoverCallBack(false)}
            id={`visible-div-marker-${keyString}-inner`}
            onClick={() => console.log('avoid crash issue!!!!')}
        >
            <Modal
                open={soilProfilePreviewVsible}
                width='950px'
                onCancel={() => setSoilProfilePreviewVsible(false)}
                title={'Soil Profile Preview'}
                centered
                footer={null}
                style={{
                    width: '950px',
                    borderRadius: '16px',
                    overflow: 'hidden',
                    zIndex: '999'
                }}
                closeIcon={<SoilCloseIcon />}
            >
                <SoilProfilePreview
                    profileDetail={profileDetail}
                    layerDetail={layerDetail}
                    profileDatailSpin={profileDatailSpin}
                    propertySet={propertySet}
                    openFromSoilSearch={true}
                />
            </Modal>
            <svg onClick={(e) =>{
                clickBUttonToSHowProfileDetail();
                e.stopPropagation();
            } } className='marker-svgIcon' width="42px" height="52px" viewBox="0 0 42 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M15.0765 41.153C6.36274 38.5959 0 30.541 0 21C0 9.40202 9.40202 0 21 0C32.598 0 42 9.40202 42 21C42 30.541 35.6373 38.5959 26.9235 41.153L21.8944 51.2111C21.5259 51.9482 20.4741 51.9482 20.1056 51.2111L15.0765 41.153Z" fill="white"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M21 39C30.9411 39 39 30.9411 39 21C39 11.0589 30.9411 3 21 3C11.0589 3 3 11.0589 3 21C3 30.9411 11.0589 39 21 39Z" fill="#19A04B"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M31 13H11V15H31V13ZM13 21H11V23H13V21ZM13 17H15V19H13V17ZM15 25H13V27H15V25ZM19 21H21V23H19V21ZM23 17H21V19H23V17ZM21 25H23V27H21V25ZM29 21H27V23H29V21ZM29 17H31V19H29V17ZM31 25H29V27H31V25ZM15 21H17V23H15V21ZM19 17H17V19H19V17ZM17 25H19V27H17V25ZM25 21H23V23H25V21ZM25 17H27V19H25V17ZM27 25H25V27H27V25Z" fill="white"/>
            </svg>
            {visible && (
                <div style={{ top: `${yPoint}`, right: `${xPoint}` }} className='soil-profile-spin-container'>
                    <Spin spinning={spinning}>
                        <div className='soil-profile-detail-div'>
                            <div className='profile-name-div'>
                                <span> {profileDetail?.name}</span>
                                <span> {profileDetail?.code}</span>
                            </div>
                            <div className='profile-detail-div'>
                                <div className='left-detail-div'>
                                    <div>
                                        <span>Location</span>
                                        <span>{profileDetail?.countryName}</span>
                                    </div>
                                    <div>
                                        <span>Soil Analysis</span>
                                        <span>{profileDetail?.analysisDate?.substring(0, 10).replace(/\//g, '-')}</span>
                                    </div>
                                </div>
                                <div className='right-detail-div'>
                                    <div>
                                        <span>Type</span>
                                        <span>{profileDetail?.fiTyName}</span>
                                    </div>
                                    <div>
                                        <span>Max Depth</span>
                                        <span>{profileDetail?.depth}</span>
                                    </div>
                                </div>
                            </div>
                            <div className='click-button-div'>
                                Click on the pin to view Soil Profile
                            </div>
                        </div>
                    </Spin>
                </div>
            )}
        </div>
    );
};

export default SoilProfileMarker;